// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_DATA = 'LOADING_DATA';
export const STOP_LOADING_UI = 'STOP_LOADING_UI';
export const CLOSE_ENROLL_DIALOG = 'CLOSE_ENROLL_DIALOG';
export const OPEN_QUIZ = 'OPEN_QUIZ';
export const CLOSE_QUIZ_DONE = 'CLOSE_QUIZ_DONE';
export const CLOSE_QUIZ_ABANDON = 'CLOSE_QUIZ_ABANDON';
// Data reducer types
export const LOAD_CLASSES = 'LOAD_CLASSES';
export const LOAD_USER_CLASSES = 'LOAD_USER_CLASSES';
export const LOAD_CLASS_SYLLABUS = 'LOAD_CLASS_SYLLABUS';
export const SET_USER_CLASSES = 'SET_USER_CLASSES';
export const ENROLL_TO_CLASS = 'ENROLL_TO_CLASS';
export const UPDATE_DAY_CARD = 'UPDATE_DAY_CARD';
export const SET_CLASS = 'SET_CLASS';
export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
export const LOAD_MILESTONES = 'LOAD_MILESTONES';
export const UPDATE_NOTIFICATIONS_CARD = 'UPDATE_NOTIFICATIONS_CARD';
export const LOAD_CHAT_GROUP = 'LOAD_CHAT_GROUP';
export const LOAD_AUTOPILOT_GROUP = 'LOAD_AUTOPILOT_GROUP';
export const GET_SURVEY_STATUS = 'GET_SURVEY_STATUS';